import { render, staticRenderFns } from "./PrepCoursesList.vue?vue&type=template&id=6f4acb3e&"
import script from "./PrepCoursesList.vue?vue&type=script&lang=js&"
export * from "./PrepCoursesList.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports